import {ShowProductPayloadDto} from '@features/product/application/use_cases/show-product/dto/show-product.payload.dto';
import {ShowProductResponseDto} from '@features/product/application/use_cases/show-product/dto/show-product.response.dto';
import {ShowProductHttpPayloadDto} from '@features/product/infrastructure/http/show-product/show-product.http.payload.dto';
import {ShowProductHttpResponseDto} from '@features/product/infrastructure/http/show-product/show-product.http.response.dto';

export class ShowProductHttpMapper {

  static toResponse(data: ShowProductHttpResponseDto): ShowProductResponseDto {
    return {};
  }

  static toInfra(data: ShowProductPayloadDto): ShowProductHttpPayloadDto {
    return {};
  }

}
